import { i18n } from "@/libs/i18n";

export const isDefinedLocale = (locale: string): boolean => {
  return i18n.locales.some((definedLocale) => definedLocale === locale);
};
